'use client'
import { openSupportEmail } from '@repo/utils/emailSupport'
import { OspreyIllustration } from '@repo/ui/OspreyIllustration'
import MUITypography from '@mui/material/Typography'
import MUIStack from '@mui/material/Stack'
import MUIButton from '@mui/material/Button'

const Support = () => {
  return (
    <MUIStack
      direction="row"
      sx={{ margin: '140px auto', padding: '24px 40px 40px', maxWidth: '800px' }}
      gap={'20px'}
      alignItems="center"
      justifyContent="center"
    >
      <OspreyIllustration />

      <MUIStack
        direction="column"
        sx={{ width: '440px', margin: '0 auto', padding: '24px 40px 40px' }}
        gap={'24px'}
        alignItems="left"
        justifyContent="center"
      >
        <MUITypography variant="h2" sx={{ mt: 0, mb: 0 }}>
          {`We're here to help`}
        </MUITypography>

        <MUITypography variant="body1" sx={{ color: 'text.primary', mb: 6 }}>
          {`Please click the button below to email Support. This will open an email containing useful info to help the Support Team solve your issue as quickly as possible.`}
        </MUITypography>

        <MUIButton variant="contained" color="primary" onClick={openSupportEmail}>
          Request 1-1 support
        </MUIButton>
      </MUIStack>
    </MUIStack>
  )
}

export default Support
